import {
  CoachingDashboardItemNode,
  CoachingMetaNode,
} from "types/graphql-schema";

import { titleCase } from "@helpers/string";

import { DimensionIcon, StatusBadge } from "./coaching-components";
import type { Status } from "./coaching-constants";

const formatDate = (dateStr: string) => {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const MetaStats = ({
  meta,
  sourceCount,
}: {
  meta: CoachingMetaNode;
  sourceCount: number;
}) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-gray-200 rounded-lg bg-white shadow-sm ring-1 ring-gray-900/5">
    {[
      { label: "Role", value: meta.report?.role ?? "" },
      { label: "Tenure", value: meta.report?.tenure ?? "" },
      {
        label: "Period",
        value:
          meta.period?.start && meta.period?.end
            ? `${formatDate(meta.period.start)} – ${formatDate(meta.period.end)}`
            : "",
      },
      { label: "Sources", value: String(sourceCount) },
    ].map((stat) => (
      <div key={stat.label} className="px-4 py-4 sm:px-5">
        <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">
          {stat.label}
        </dt>
        <dd className="mt-1 text-sm font-semibold text-gray-900">
          {stat.value}
        </dd>
      </div>
    ))}
  </div>
);

export const DashboardGrid = ({
  cards,
}: {
  cards: CoachingDashboardItemNode[];
}) => (
  <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
    {cards.map((card, index) => (
      <div
        key={`${card?.dimension ?? "unkown"}-${index}`}
        className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow-sm ring-1 ring-gray-900/5"
      >
        <div className="flex items-center gap-2">
          <DimensionIcon
            name={card?.dimension ?? ""}
            className="h-4 w-4 text-gray-400 shrink-0"
          />
          <dt className="truncate text-sm font-medium text-gray-500">
            {card?.dimension}
          </dt>
        </div>
        <dd className="mt-2">
          <StatusBadge
            status={(card?.status ?? "good") as Status}
            label={titleCase(card?.statusLabel ?? "")}
          />
        </dd>
        <dd className="mt-2 text-sm text-gray-500 leading-snug">
          {card?.detail}
        </dd>
      </div>
    ))}
  </dl>
);
